import { TicketCategory } from './types';

/**
 * FE-only derivation of the duration/scope description the BE Ticketshop Step 1
 * response (§6) does not provide.
 *
 * Derived from `category` + ticket `name` instead of a per-id map, so it works
 * regardless of env — backend ids differ between staging/prod, but category
 * and the (conventional German) ticket name do not. Step 1 does not transmit
 * the validity period, so the duration is inferred from the name.
 *
 * TODO: ticketshop - drop this deriver once the BE returns the description on
 * the Step 1 response.
 */

/**
 * `ticketshop` translation key for the duration/scope description shown on the
 * card, inferred from category + name keyword. Returns undefined when unknown
 * (then no description is shown).
 */
export const deriveTicketDescriptionKey = (
	category: TicketCategory,
	name: string
): string | undefined => {
	if (category === 'short-trip') {
		return 'operator_tickets.description_short_trip';
	}

	const normalized = name.toLowerCase();
	if (normalized.includes('woche')) return 'operator_tickets.description_week';
	if (normalized.includes('monat')) return 'operator_tickets.description_month';
	if (normalized.includes('jahr')) return 'operator_tickets.description_year';
	if (normalized.includes('tag')) return 'operator_tickets.description_day';

	return undefined;
};
